import { render, staticRenderFns } from "./AppLoaderComponent.vue?vue&type=template&id=6f9b5842&"
import script from "./AppLoaderComponent.vue?vue&type=script&lang=js&"
export * from "./AppLoaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./AppLoaderComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports